<template>
	<h1 v-if="pageTitle" class="large-title single-page-title padding-bottom-sm" v-html="pageTitle"></h1>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'page-title',
    computed: {
        ...mapGetters([
            'currentPage',
            'isFrontPage'
        ]),
        pageTitle(){
            if(this.isFrontPage && this.currentPage && this.currentPage.acf && this.currentPage.acf.home_banner && this.currentPage.acf.home_banner.title) return this.currentPage.acf.home_banner.title
            if(this.currentPage && this.currentPage.title) return this.currentPage.title
        }
    },
    
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.single-page-title{
    margin-top: 10px;
    margin-bottom: 0;
    max-width: 800px;
}
</style>
